import React from "react";
import { MultipleChoiceToggleGroup } from "@mdxeditor/editor/plugins/toolbar/primitives/toolbar";
import { corePluginHooks } from "@mdxeditor/editor/plugins/core";

// Format constants (not exported from package, using values directly)
const IS_BOLD = 1;
const IS_ITALIC = 2;
const IS_UNDERLINE = 8;

// Custom toggle component that conditionally excludes specified format options
const ConditionalBoldItalicUnderlineToggles = ({
  disableBoldItalicUnderline = [],
}) => {
  const [currentFormat] = corePluginHooks.useEmitterValues("currentFormat");
  const applyFormat = corePluginHooks.usePublisher("applyFormat");
  const [iconComponentFor] =
    corePluginHooks.useEmitterValues("iconComponentFor");

  const boldIsOn = (currentFormat & IS_BOLD) !== 0;
  const italicIsOn = (currentFormat & IS_ITALIC) !== 0;
  const underlineIsOn = (currentFormat & IS_UNDERLINE) !== 0;

  const boldTitle = boldIsOn ? "Remove bold" : "Bold";
  const italicTitle = italicIsOn ? "Remove italic" : "Italic";
  const underlineTitle = underlineIsOn ? "Remove underline" : "Underline";

  const disabledOptions = Array.isArray(disableBoldItalicUnderline)
    ? disableBoldItalicUnderline.map((opt) => opt.toLowerCase())
    : [];

  const items = [];

  if (!disabledOptions.includes("bold")) {
    items.push({
      title: boldTitle,
      contents: iconComponentFor("format_bold"),
      active: boldIsOn,
      onChange: applyFormat.bind(null, "bold"),
    });
  }

  if (!disabledOptions.includes("italic")) {
    items.push({
      title: italicTitle,
      contents: iconComponentFor("format_italic"),
      active: italicIsOn,
      onChange: applyFormat.bind(null, "italic"),
    });
  }

  if (!disabledOptions.includes("underline")) {
    items.push({
      title: underlineTitle,
      contents: (
        <div style={{ transform: "translateY(2px)" }}>
          {iconComponentFor("format_underlined")}
        </div>
      ),
      active: underlineIsOn,
      onChange: applyFormat.bind(null, "underline"),
    });
  }

  return <MultipleChoiceToggleGroup items={items} />;
};

export default ConditionalBoldItalicUnderlineToggles;
